import { Component, Vue } from 'vue-property-decorator';
import FootBar from './footer/footer.vue';

/**
 * 框架
 */
@Component({ name: 'Layout', components: { FootBar } })
export default class extends Vue {

}
